// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1d-p5","messages":"Chat_messages__2fcRG","dateDivider":"Chat_dateDivider__1Xlyh"};